import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitAthleteEntryRelayAthleteByMeetEventIdData from './GetOrgUnitAthleteEntryRelayAthleteByMeetEventIdData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  meetEventId: Constants.DEFAULT_ID
};

const RelayAthleteMeetEventData = {
  INITIAL_STATE, getOrgUnitAthleteEntryRelayAthleteByMeetEventIdData
}

export default RelayAthleteMeetEventData;